import { render } from "./view.vue?vue&type=template&id=fa9a6a70&ts=true"
import script from "./view.vue?vue&type=script&lang=ts"
export * from "./view.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Pages/Admin/Prizes/view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fa9a6a70"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fa9a6a70', __exports__)) {
    api.reload('fa9a6a70', __exports__)
  }
  
  module.hot.accept("./view.vue?vue&type=template&id=fa9a6a70&ts=true", () => {
    api.rerender('fa9a6a70', render)
  })

}


export default __exports__